import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';

import { makeStyles } from '@material-ui/core';

import styles from './styles';

const OktaSignInWidget = ({ config, onSuccess, onError }) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const widgetRef = useRef();
  useEffect(() => {
    if (!widgetRef.current)
      return false;

    const widget = new OktaSignIn(config);

    widget.renderEl({
      el: widgetRef.current,
    }).then(onSuccess).catch(onError);

    return () => widget.remove();
  }, [config, onSuccess, onError]);

  return (<div ref={widgetRef} className={classes.okta} />);
};

OktaSignInWidget.propTypes= {
  config: PropTypes.shape(),
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
}

export default OktaSignInWidget;